import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import EntryIcon from './EntryIcon';
import {ENTRY_TYPES, TYPE_LABELS} from '../entryTypes';

const pad = (n) => String(n).padStart(2, '0');

const toLocalInputValue = (date) =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;

const AddEntryModal = ({isOpen, onRequestClose, onSave}) => {
    const [value, setValue] = useState(() => toLocalInputValue(new Date()));
    const [entryType, setEntryType] = useState('pee');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setValue(toLocalInputValue(new Date()));
            setEntryType('pee');
            setSaving(false);
        }
    }, [isOpen]);

    const handleSave = async () => {
        const date = new Date(value);
        if (isNaN(date.getTime())) return;
        setSaving(true);
        await onSave(date.toISOString(), entryType);
        onRequestClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Add entry"
            overlayClassName="confirm-modal-overlay"
            className="confirm-modal-content"
        >
            <p className="confirm-message">Add an entry</p>
            <span className="add-entry-label" id="add-entry-type-label">Type</span>
            <div className="type-toggle" role="group" aria-labelledby="add-entry-type-label">
                {ENTRY_TYPES.map((option) => (
                    <button
                        key={option}
                        type="button"
                        className={`type-toggle-option type-toggle-${option} ${entryType === option ? 'is-selected' : ''}`}
                        aria-pressed={entryType === option}
                        onClick={() => setEntryType(option)}
                    >
                        <EntryIcon type={option} className="type-toggle-icon"/>
                        {TYPE_LABELS[option]}
                    </button>
                ))}
            </div>
            <label className="add-entry-label" htmlFor="add-entry-time">Time</label>
            <input
                id="add-entry-time"
                className="add-entry-input"
                type="datetime-local"
                value={value}
                max={toLocalInputValue(new Date())}
                onChange={(event) => setValue(event.target.value)}
            />
            <div className="confirm-actions">
                <button className="confirm-cancel" onClick={onRequestClose} disabled={saving}>Cancel</button>
                <button className="confirm-save" onClick={handleSave} disabled={saving}>
                    {saving ? 'Saving…' : 'Save'}
                </button>
            </div>
        </Modal>
    );
};

export default AddEntryModal;
